import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FieldProps } from '@progress/kendo-react-form';

export const EmployerEditor = (props: FieldProps, employerList: any) => {
    const handleChange = (event: DropDownListChangeEvent) => {
        if (props.onChange) {
            props.onChange.call(undefined, { value: event.value.id });
        }
    };
    const { validationMessage, visited } = props;
    return (
        <>
            <DropDownList
                style={{ backgroundColor: 'white' }}
                onChange={handleChange}
                value={employerList.find((t: any) => t.id === props.value)}
                data={employerList}
                dataItemKey={'id'}
                textField={'employerName'}
            />
            {visited && validationMessage && <span className="help-block m-b-none text-danger field-validation-valid">{validationMessage}</span>}
        </>
    );
};

export const ActivityEditor = (props: FieldProps, activityList: any) => {
    const handleChange = (event: DropDownListChangeEvent) => {
        if (props.onChange) {
            props.onChange.call(undefined, { value: event.value.jobSubCategoryId });
        }
    };
    const { validationMessage, visited } = props;
    return (
        <>
            <DropDownList
                style={{ backgroundColor: 'white' }}
                onChange={handleChange}
                value={activityList.find((t: any) => t.jobSubCategoryId === props.value)}
                data={activityList}
                dataItemKey={'jobSubCategoryId'}
                textField={'name'}
            />
            {visited && validationMessage && <span className="help-block m-b-none text-danger field-validation-valid">{validationMessage}</span>}
        </>
    );
};
